<div class="get-care-now-container">
    <div class="custom-container">
        <app-ask-a-doctor-mobile 
            [locale]="locale"
            [isPlus]="isPlus"
            [quickCareOptions]="quickCareOptions">
        </app-ask-a-doctor-mobile>
    </div>
    <div class="custom-container">
        <app-virtual-urgent-care-mobile 
            [locale]="locale"
            [isPlus]="isPlus"
            [virtualUrgentCareOptions]="virtualUrgentCareOptions">
        </app-virtual-urgent-care-mobile>
    </div>
    <div class="custom-container">
        <app-in-person-urgent-care-mobile 
            [locale]="locale"
            [isPlus]="isPlus"
            [inpersonUrgentCareOptions]="inpersonUrgentCareOptions">
        </app-in-person-urgent-care-mobile>
    </div>
    <div *ngIf="primaryCareProviderOptions && primaryCareProviderOptions != null && primaryCareProviderOptions.length > 0" class="custom-container">
        <app-primary-care-provider-mobile 
        [locale]="locale"
        [isPlus]="isPlus"
        [primaryCareProviderOptions]="primaryCareProviderOptions"
        [pcpId]="pcpId">
    </app-primary-care-provider-mobile>
    </div>
    <div class="need-help-container">
       <app-need-help-deciding 
            [locale]="locale">
        </app-need-help-deciding>
    </div>
</div>

